// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__1oQu8","menuItem":"menu_menuItem__383C_"};